export default __webpack_public_path__ + "static/media/Verdana-Bold-Italic.76eb4b43.ttf";